import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ThemeWrapper from '../ThemeWrapper ';
import Loader from '../components/Loader';

const MyCalendar = () => {
    const [calendar, setCalendar] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCalendar = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    url: `${params.baseURL}${params.endpoints.getMyCalendar}`,
                    data: formData,
                });

                if (response.data.items && Array.isArray(response.data.items)) {
                    setCalendar(response.data.items);
                    setLoading(false);
                } else {
                    setError('An error occurred while fetching data.');
                }
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchCalendar();
    }, []);

    const openCalendarPage = (listing) => {
        navigate(`/rooms-price/${listing.stay_listing_id}`);
    };

    const faqs = [
        {
            question: "What is Lorem Ipsum?",
            answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },
        {
            question: "Where does it come from?",
            answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
        },
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Calendar</title>
                <meta name='description' content='' />
            </Helmet>

            <div className='row'>
                <div className='col-md-8'>

                    {calendar.length > 0 ? (
                        <>
                            <div className='yl-header'>
                                <div className='img-title-box'>
                                    <img src={'/assets/img/title/calendar_title_2.svg'} className='img-fluid img-title' alt='' />
                                </div>
                            </div>
                            <div className='row'>
                                {calendar.map((data) => (
                                    <div className='col-md-12 lb mb-3' key={data.stay_listing_id}>
                                        <ThemeWrapper categoryId={data.category_id}>
                                            <a href='javascript:void(0);' className='mcldb' onClick={() => openCalendarPage(data)}>
                                                <div className='mcaldbox'>
                                                    <div className='mcd-image'>
                                                        <img
                                                            src={data.cover_photo ? data.cover_photo : '/assets/img/default_listing.jpg'}
                                                            alt={data.listing_title ? data.listing_title : 'Untitled Listing'}
                                                        />
                                                    </div>
                                                    <div className='mcd-title'>
                                                        <img src={data.property_title_icon_image} alt='' className='img-fluid pointer-icon' style={{ boxShadow: 'none' }} />
                                                        <div className='wspl-ta-section' style={{ fontWeight: '600' }}>
                                                            <span>{data.listing_title ? data.listing_title : ''}</span>
                                                            <span style={{ marginLeft: '5px', color: 'darkgray' }}>{data.property_address ? data.property_address : ''}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='cal-img'>
                                                    <img src={'assets/img/icons/calendar_manager_2.svg'} alt='' className='img-fluid' />
                                                </div>
                                            </a>
                                        </ThemeWrapper>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <div className="d-flex flex-column justify-content-center align-items-center vh-100">
                            <i className="bi bi-calendar text-secondary" style={{ fontSize: "3.5rem" }}></i>
                            <h4 className="mt-3">No Data Found</h4>
                            <p className="text-muted">Looks like you don’t have any Data yet.</p>
                        </div>
                    )}
                </div>
                <div className='col-md-4 p-0'>
                    <div className='bfhsd'>
                        <div className='blog-box'>
                            <div class="blog">
                                <div class="blog-image">
                                    <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                                    <div class="date">May 08, 2025</div>
                                </div>
                                <div class="blog-content">
                                    <h2>What is Lorem Ipsum?</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                                    <a href="#">Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="bfaq-sticky">
                            {faqs.map((faq, index) => (
                                <div key={index} className='faqs-list-section'>
                                    <div
                                        onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                                        style={{
                                            backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                                        }}
                                    >
                                        {faq.question}
                                        <i
                                            className={`fas ${activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                                                }`}
                                            style={{
                                                transition: "transform 0.3s ease",
                                            }}
                                        ></i>
                                    </div>
                                    {activeIndex === index && (
                                        <div className='faqs-ans-box'>
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default MyCalendar;
